import {Authority} from "root/Common/Constants/PassportAuthorityTypes.mjs";
import {constructNodePdfUrl, NCL_PDFS} from "root/DataFunctions/PdfDataFns";

const HeaderLogos = {
    [Authority.NCC] : {
        path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
            height: '80px',
            width: '160px',
            title: 'School Readiness Passport',
            subtitle: 'Northumberland Early Years',
        },
    [Authority.GHD] : {
        path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
        height: '80px',
        width: '160px',
        title: 'School Readiness Passport',
        subtitle: '',
    },
    [Authority.SUN] : {
        path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
        height: '80px',
        width: '160px',
        title: 'School Readiness Passport',
        subtitle: '',
    },
    [Authority.DUR] : {
        path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
        height: '80px',
        width: '160px',
        title: 'School Readiness Passport',
        subtitle: '',
    },
    [Authority.STC] : {
        path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
        height: '80px',
        width: '160px',
        title: 'School Readiness Passport',
        subtitle: '',
    },
    [Authority.NCL] : {
        path: '/style/images/seven360/ncl/passport_logo.png',
        height: '60px',
        width: '180px',
        title: 'School Readiness Passport',
        subtitle: '',
    },
    [Authority.NTC] : {
        path: '/style/images/seven360/ntc/Digital_FullCol_Hor_white_text.png',
        height: '80px',
        width: '180px',
        title: 'School Readiness Passport',
        subtitle: '',
    },
    default : {
        path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
        height: '80px',
        width: '160px',
        title: 'School Readiness Passport',
        subtitle: 'Northumberland Early Years',
    },
}

export const getheaderDescriptor = ( authority_id ) =>
{
    return HeaderLogos[authority_id] === undefined ? HeaderLogos.default : HeaderLogos[authority_id];
}

const LoginParams = {

    [Authority.NCC] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ncc_logo.png',
        logoWidth: '100%',
    },
    [Authority.NCL] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ncl/logonlogo.svg',
        logoWidth: '349px',
    },
    [Authority.NTC] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ntc/Digital_FullCol_Hor.png',
        logoWidth: '400px',
    },
    [Authority.GHD] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ghd/login_logo.png',
        logoWidth: '400px',
    },
    [Authority.SUN] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ghd/login_logo.png',
        logoWidth: '400px',
    },
    [Authority.DUR] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ghd/login_logo.png',
        logoWidth: '400px',
    },
    [Authority.STC] : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ghd/login_logo.png',
        logoWidth: '400px',
    },
    default : {
        backgroundImage: '/style/images/art/slider-bg26.jpg',
        panelBackgroundColor: 'rgba(255, 255, 255, 0.72)',
        logo:'/style/images/seven360/ncc_logo.png',
        logoWidth: '100%',
    },
}

export const getLoginParams = ( authority_id ) =>
{
    return LoginParams[authority_id] === undefined ? LoginParams.default : LoginParams[authority_id];
}

export const headerLogoNorthumberland = {
    path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
    height: '80px',
    width: '160px',
    title: 'School Readiness Passport',
    subtitle: 'Northumberland Early Years',
}


const getHeaderMenuDescriptors = (data) => {

    return {
        [Authority.NCC] : [
            { type: 'link', href: "/Training_FAQs.pdf?ver=1", target: "_blank", text: "Training FAQs" },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
                    { type: 'item', href: "/Early_Years_SLA_2025-2026_2.pdf", target: "_blank", text: 'Early Years SLA' },
                    { type: 'divider' },
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ],
        [Authority.GHD] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ],
        [Authority.NCL] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ],
        [Authority.NTC] : [
            { type: 'dropdown', title: 'Privacy', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/Parental_Consent_Form.docx", target: "_blank", text: 'Parental Consent Form' },
                    { type: 'item', href: constructNodePdfUrl(NCL_PDFS.PRIVACY, data.login_jwt, null), target: "_blank", text: 'Privacy Notice' },
                ] },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ],
        default : [
            { type: 'link', href: "/Training_FAQs.pdf?ver=1", target: "_blank", text: "Training FAQs" },
            { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
                    { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
                    { type: 'item', href: "/Early_Years_SLA_2025-2026_2.pdf", target: "_blank", text: 'Early Years SLA' },
                    { type: 'divider' },
                    { type: 'item', href: "/login.php?logout", text: 'Logout' },
                ] },
        ],
    }
}
export const getHeaderMenuDescriptor = ( data ) =>
{
    return getHeaderMenuDescriptors(data)[data.authority_id] === undefined ? getHeaderMenuDescriptors(data).default : getHeaderMenuDescriptors(data)[data.authority_id];
}

export const passportNorthumberlandMenu = [
    { type: 'link', href: "/Training_FAQs.pdf?ver=1", target: "_blank", text: "Training FAQs" },
    { type: 'dropdown', title: 'Options', id: 'basic-nav-dropdown', items: [
            { type: 'item', href: "/School_Readiness_Passport_Privacy_Notice_1.0.pdf", target: "_blank", text: 'Privacy Notice' },
            { type: 'item', href: "/Early_Years_SLA_2025-2026_2.pdf", target: "_blank", text: 'Early Years SLA' },
            { type: 'divider' },
            { type: 'item', href: "/login.php?logout", text: 'Logout' },
        ] },
]
